import { render } from "./IdentityMapContainer.vue?vue&type=template&id=2dc040fe"
import script from "./IdentityMapContainer.vue?vue&type=script&lang=js"
export * from "./IdentityMapContainer.vue?vue&type=script&lang=js"

import "./IdentityMapContainer.vue?vue&type=style&index=0&id=2dc040fe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__